export default "__VITE_ASSET__C$cTveyR__"